module.exports = __webpack_public_path__ + "static/img/my_amount.b0ea35ea.png";